import React from 'react'
import ProgressRing from './ProgressRing'
import styles from './DesktopChallanPPED.module.scss'

type DaysLeftRingProps = {
  daysLeft: number
}

const DaysLeftRing = ({ daysLeft }: DaysLeftRingProps) => (
  <div className={styles.daysLeftCircle}>
    {daysLeft > 0 ? (
      <ProgressRing progress={1 - (daysLeft / 60)} value={daysLeft} label="days left" />
    ) : (
      <ProgressRing
        progress={1}
        value={daysLeft * -1}
        label={
          <>
            days
            <br />
            overdue
          </>
        }
      />
    )}
  </div>
)

export default DaysLeftRing
